export const APP_NAME = 'Valmate';
export const APP_TAGLINE =
  'Free instant property valuations for UK estate agents. Embed it on your site, capture more valuation leads, book more instructions.';

export const COLORS = {
  coral: '#f47a6b',
  coralHover: '#e56a5a',
  navy: '#0f172a',
} as const;

export const POSTCODES_IO_BASE = 'https://api.postcodes.io';
